module.exports = __webpack_public_path__ + "static/media/footer_pink.d8fd5037.png";